import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import WizardSteps from './wizard-steps';

import BasketOverview from './wizard/BasketOverview';
import ContactInfo from './wizard/ContactInfo';
import SimpleContactInfo from './wizard/SimpleContactInfo';
import OrderProcessing from './wizard/OrderProcessing';
import OrderFailed from './wizard/OrderFailed';

class BasketPage extends React.Component {

    render() {
        const {props: {basket: {wizardStep}}} = this;

        switch (wizardStep) {
            case WizardSteps.BASKET_OVERVIEW:
                return <BasketOverview />;
            case WizardSteps.CONTACT_INFO:
                return <ContactInfo />;
            case WizardSteps.SIMPLE_CONTACT_INFO:
                return <SimpleContactInfo />;
            case WizardSteps.ORDER_PROCESSING:
                return <OrderProcessing  />;
            case WizardSteps.ORDER_FAILED:
                return <OrderFailed />;
        }
    }
}

const mapStateToProps = (state) => ({
  basket: state.basket
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BasketPage);
